import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Status/config';
import cn from 'classnames';
import s from './Status.scss';
const StatusViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize, presetId }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: presetId !== null && presetId !== void 0 ? presetId : 'deviation-status',
        contentJson: contentJson,
        className: cn(s['root'], s[`preset-${presetId}`], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
StatusViewer.displayName = 'StatusViewer';
export default StatusViewer;

//# sourceMappingURL=Status.js.map